import { createSlice } from "@reduxjs/toolkit";
import {
    getMarketingKpisData,
    getMarketingLeadsMensualesData,
    getMarketingPorFuenteData,
    getMarketingEmbudoData,
    getMarketingCostePorLeadData,
    getMarketingParcialData,
    getGscKpisData,
    getGscEvolucionData,
    getGscQueriesData,
    getGscPagesData,
} from './thunk';

const initialState = {
    kpis: null,
    leadsMensuales: null,
    porFuente: null,
    embudo: null,
    costePorLead: null,
    parcial: null,
    gsc: {
        kpis: null,
        evolucion: null,
        queries: null,
        pages: null,
        error: null,
    },
    loading: {
        kpis: false, leads: false, fuente: false, embudo: false,
        coste: false, parcial: false,
        gscKpis: false, gscEvolucion: false, gscQueries: false, gscPages: false,
    },
    error: null,
};

const DashboardMarketingSlice = createSlice({
    name: 'DashboardMarketing',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMarketingKpisData.pending,         (s) => { s.loading.kpis = true; })
            .addCase(getMarketingKpisData.fulfilled,       (s, a) => { s.loading.kpis = false; s.kpis = a.payload; })
            .addCase(getMarketingKpisData.rejected,        (s, a) => { s.loading.kpis = false; s.error = a.error.message; })

            .addCase(getMarketingLeadsMensualesData.pending,   (s) => { s.loading.leads = true; })
            .addCase(getMarketingLeadsMensualesData.fulfilled, (s, a) => { s.loading.leads = false; s.leadsMensuales = a.payload; })
            .addCase(getMarketingLeadsMensualesData.rejected,  (s) => { s.loading.leads = false; })

            .addCase(getMarketingPorFuenteData.pending,   (s) => { s.loading.fuente = true; })
            .addCase(getMarketingPorFuenteData.fulfilled, (s, a) => { s.loading.fuente = false; s.porFuente = a.payload; })
            .addCase(getMarketingPorFuenteData.rejected,  (s) => { s.loading.fuente = false; })

            .addCase(getMarketingEmbudoData.pending,   (s) => { s.loading.embudo = true; })
            .addCase(getMarketingEmbudoData.fulfilled, (s, a) => { s.loading.embudo = false; s.embudo = a.payload; })
            .addCase(getMarketingEmbudoData.rejected,  (s) => { s.loading.embudo = false; })

            .addCase(getMarketingCostePorLeadData.pending,   (s) => { s.loading.coste = true; })
            .addCase(getMarketingCostePorLeadData.fulfilled, (s, a) => { s.loading.coste = false; s.costePorLead = a.payload; })
            .addCase(getMarketingCostePorLeadData.rejected,  (s) => { s.loading.coste = false; })

            .addCase(getMarketingParcialData.pending,   (s) => { s.loading.parcial = true; })
            .addCase(getMarketingParcialData.fulfilled, (s, a) => { s.loading.parcial = false; s.parcial = a.payload; })
            .addCase(getMarketingParcialData.rejected,  (s) => { s.loading.parcial = false; })

            // Search Console
            .addCase(getGscKpisData.pending,       (s) => { s.loading.gscKpis = true; s.gsc.error = null; })
            .addCase(getGscKpisData.fulfilled,     (s, a) => { s.loading.gscKpis = false; s.gsc.kpis = a.payload; })
            .addCase(getGscKpisData.rejected,      (s, a) => { s.loading.gscKpis = false; s.gsc.error = a.error.message; })

            .addCase(getGscEvolucionData.pending,   (s) => { s.loading.gscEvolucion = true; })
            .addCase(getGscEvolucionData.fulfilled, (s, a) => { s.loading.gscEvolucion = false; s.gsc.evolucion = a.payload; })
            .addCase(getGscEvolucionData.rejected,  (s) => { s.loading.gscEvolucion = false; })

            .addCase(getGscQueriesData.pending,   (s) => { s.loading.gscQueries = true; })
            .addCase(getGscQueriesData.fulfilled, (s, a) => { s.loading.gscQueries = false; s.gsc.queries = a.payload; })
            .addCase(getGscQueriesData.rejected,  (s) => { s.loading.gscQueries = false; })

            .addCase(getGscPagesData.pending,   (s) => { s.loading.gscPages = true; })
            .addCase(getGscPagesData.fulfilled, (s, a) => { s.loading.gscPages = false; s.gsc.pages = a.payload; })
            .addCase(getGscPagesData.rejected,  (s) => { s.loading.gscPages = false; });
    }
});

export default DashboardMarketingSlice.reducer;
